export const heroStats = [
  { label: '在蹲话题', value: '1,286', unit: '个' },
  { label: '今日实时更新', value: '342', unit: '条' },
  { label: '一起围观的群众', value: '98.6', unit: '万' },
]

export const heroHotLine = [
  '新剧开播首周反转名场面，弹幕齐刷"伏笔早就埋好了"',
  '两场直播撞档同一天，网友把时间线整理成了长图',
  '音乐节阵容临时微调，主办方深夜发长文回应',
]

export const frontRowItems = [
  {
    id: 'fr-01',
    tag: '影视圈',
    title: '新剧开播首周就迎反转，网友：这段早有伏笔',
    summary: '第二集埋下的细节被逐帧扒出，评论区直接变成推理现场，蹲后续的人越来越多。',
    heat: '9.8万',
    comments: '3,204',
    time: '12 分钟前',
  },
  {
    id: 'fr-02',
    tag: '综艺',
    title: '录制现场路透流出，这组默契值被网友反复回放',
    summary: '一段几秒的同框被做成慢放对比，前后排网友就"是不是巧合"聊到停不下来。',
    heat: '7.2万',
    comments: '1,865',
    time: '26 分钟前',
  },
  {
    id: 'fr-03',
    tag: '品牌',
    title: '两家品牌同天官宣，时间线被评论区扒得明明白白',
    summary: '从海报配色到发布时间，围观群众把两条官微翻到了去年，就为找一条隐藏线索。',
    heat: '6.4万',
    comments: '2,110',
    time: '48 分钟前',
  },
  {
    id: 'fr-04',
    tag: '音乐',
    title: '音乐节阵容临时微调，主办方深夜长文回应',
    summary: '一则简短公告引发大量猜测，随后主办方补充说明换场原因，网友表示"可以理解但想看"。',
    heat: '5.1万',
    comments: '980',
    time: '1 小时前',
  },
  {
    id: 'fr-05',
    tag: '短剧',
    title: '短剧出海成绩单出炉，海外网友蹲字幕更新',
    summary: '评论区出现多语种催更，有观众自发整理人物关系图，讨论度一路走高。',
    heat: '4.7万',
    comments: '1,336',
    time: '2 小时前',
  },
  {
    id: 'fr-06',
    tag: '直播',
    title: '两场直播意外撞档，网友边看边做时间线对照',
    summary: '同一晚开播的两场活动被网友排成表格，弹幕里全是"我这边刚说完那边就接上了"。',
    heat: '3.9万',
    comments: '742',
    time: '3 小时前',
  },
  {
    id: 'fr-07',
    tag: '科技',
    title: '新品发布会散场后，参数党与体验党在评论区对线',
    summary: '一组实测数据被反复引用，围观群众一边等更多上手报告，一边把对比图存进收藏夹。',
    heat: '3.3万',
    comments: '1,024',
    time: '4 小时前',
  },
  {
    id: 'fr-08',
    tag: '民生',
    title: '一条城市新规征求意见，网友把细则逐条读了一遍',
    summary: '从执行时间到适用范围，评论区的提问被整理成清单，蹲一个官方后续答复。',
    heat: '2.8万',
    comments: '690',
    time: '5 小时前',
  },
]

export const followUpItems = [
  {
    id: 'fu-01',
    stamp: '今天 14:20',
    tag: '最新进展',
    title: '当事方发布补充说明，关键时间点被重新标注',
    desc: '相比早前的简短公告，这次补充了完整时间线，围观群众正在逐条对照此前整理的长图。',
  },
  {
    id: 'fu-02',
    stamp: '今天 11:05',
    tag: '进展',
    title: '有网友晒出后续现场片段，讨论方向出现新分支',
    desc: '新增素材让此前的两种说法都出现了修改空间，评论区开始重新排时间顺序。',
  },
  {
    id: 'fu-03',
    stamp: '昨天 21:40',
    tag: '待回应',
    title: '相关方尚未回应，群众把疑问整理成了清单',
    desc: '目前被顶到最上面的三条提问都围绕同一个细节，等待一个正式的说明。',
  },
  {
    id: 'fu-04',
    stamp: '昨天 18:12',
    tag: '已澄清',
    title: '早前流传的一张截图被指为旧图，已标注来源',
    desc: '热心网友翻出原始发布时间，相关讨论已更新，标题也做了修订。',
  },
  {
    id: 'fu-05',
    stamp: '前天 22:30',
    tag: '起点',
    title: '话题最初从一条随手动态开始发酵',
    desc: '最初只有零星几条转发，半天之内热度翻了几倍，围观队伍就是这样慢慢排起来的。',
  },
]

export const collections = [
  {
    id: 'col-01',
    name: '影视风向合集',
    desc: '新剧开播、名场面反转、幕后花絮，一次看全。',
    count: 128,
    tag: '索引',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20editorial%20illustration%20of%20a%20film%20clapperboard%20and%20two%20overlapping%20speech%20bubbles%2C%20soft%20coral%20and%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20calm%20muted%20palette%2C%20clean%20poster%20art%2C%20no%20text&width=500&height=500&seq=51cg-col-film-01&orientation=squarish',
  },
  {
    id: 'col-02',
    name: '综艺名场面簿',
    desc: '路透、同框、临场反应，被反复回放的那些瞬间。',
    count: 96,
    tag: '合集',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20editorial%20illustration%20of%20a%20stage%20spotlight%20and%20a%20small%20audience%20silhouette%2C%20soft%20amber%20and%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20calm%20muted%20palette%2C%20clean%20poster%20art%2C%20no%20text&width=500&height=500&seq=51cg-col-show-02&orientation=squarish',
  },
  {
    id: 'col-03',
    name: '科技参数对照',
    desc: '发布会散场之后，参数党与体验党的存档现场。',
    count: 74,
    tag: '索引',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20editorial%20illustration%20of%20abstract%20circuit%20lines%20and%20a%20small%20bar%20chart%2C%20soft%20sage%20green%20and%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20calm%20muted%20palette%2C%20clean%20poster%20art%2C%20no%20text&width=500&height=500&seq=51cg-col-tech-03&orientation=squarish',
  },
  {
    id: 'col-04',
    name: '赛场即时回放',
    desc: '比分之外，那些被逐帧讨论的瞬间与判罚。',
    count: 112,
    tag: '合集',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20editorial%20illustration%20of%20a%20stadium%20arch%20and%20a%20round%20ball%2C%20soft%20coral%20and%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20calm%20muted%20palette%2C%20clean%20poster%20art%2C%20no%20text&width=500&height=500&seq=51cg-col-sport-04&orientation=squarish',
  },
  {
    id: 'col-05',
    name: '城市民生观察',
    desc: '新规、出行、公告，群众逐条读过的那些细则。',
    count: 63,
    tag: '索引',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20editorial%20illustration%20of%20simple%20city%20buildings%20and%20a%20document%20sheet%2C%20soft%20amber%20and%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20calm%20muted%20palette%2C%20clean%20poster%20art%2C%20no%20text&width=500&height=500&seq=51cg-col-city-05&orientation=squarish',
  },
  {
    id: 'col-06',
    name: '剧综热评存档',
    desc: '短评、长评、弹幕名句，一起边看边聊的留痕。',
    count: 205,
    tag: '合集',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20editorial%20illustration%20of%20a%20notebook%20and%20a%20pencil%20with%20quote%20marks%2C%20soft%20sage%20green%20and%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20calm%20muted%20palette%2C%20clean%20poster%20art%2C%20no%20text&width=500&height=500&seq=51cg-col-review-06&orientation=squarish',
  },
]

export const rankingList = [
  { rank: 1, title: '新剧开播首周反转讨论持续走高', heat: 9862, trend: 'up' },
  { rank: 2, title: '两场直播撞档时间线整理帖', heat: 7420, trend: 'up' },
  { rank: 3, title: '品牌同天官宣的时间线复盘', heat: 6310, trend: 'flat' },
  { rank: 4, title: '音乐节阵容调整后续说明', heat: 5208, trend: 'down' },
  { rank: 5, title: '短剧出海字幕催更合集', heat: 4775, trend: 'up' },
  { rank: 6, title: '发布会实测数据对照长图', heat: 3390, trend: 'flat' },
]

export const hotTags = [
  '蹲后续',
  '前排围观',
  '名场面',
  '时间线复盘',
  '弹幕留痕',
  '合集索引',
  '即时回放',
  '新规细则',
  '路透速递',
  '舆论观察',
]

export const discussions = [
  {
    id: 'd-01',
    user: '前排小板凳',
    initial: '前',
    topic: '#新剧反转#',
    text: '第二集那个镜头我真的回放了三遍，越看越像早有安排，蹲一个官方的说法。',
    time: '5 分钟前',
    likes: 218,
  },
  {
    id: 'd-02',
    user: '瓜田观察员',
    initial: '瓜',
    topic: '#时间线复盘#',
    text: '把两条官微按发布时间排了一下，果然能对上，围观群众的眼睛是雪亮的。',
    time: '18 分钟前',
    likes: 176,
  },
  {
    id: 'd-03',
    user: '不落空小队',
    initial: '不',
    topic: '#蹲后续#',
    text: '每天中午刷一遍合集，就怕错过更新，这个索引页做得挺省事。',
    time: '42 分钟前',
    likes: 94,
  },
  {
    id: 'd-04',
    user: '理性围观中',
    initial: '理',
    topic: '#边看边聊#',
    text: '先别急着下定论，等完整说明出来再聊，现在讨论区气氛还挺好的。',
    time: '1 小时前',
    likes: 143,
  },
  {
    id: 'd-05',
    user: '深夜蹲守党',
    initial: '深',
    topic: '#即时回放#',
    text: '昨晚那场直播的片段整理得太快了吧，一觉醒来时间线都做好了。',
    time: '2 小时前',
    likes: 87,
  },
]